import React from 'react';
import { PanelCards } from '../../../Panel';
import { FHA, HARVEST, WEATHER } from '../../../../constants/cards';
import { PlantingCard } from '../../../cards/PlantingCard';

const CARDS = [WEATHER, HARVEST, FHA];


export interface PlantingHybridPanelProps {
  index: number;
  isCollapsed?: boolean;
}

export function PlantingHybridPanel({ index, isCollapsed }: PlantingHybridPanelProps) {
  const firstCard = <PlantingCard index={index} />

  return (
    <PanelCards
      cards={CARDS}
      firstCard={firstCard}
      index={index}
      isCollapsed={isCollapsed}
      testId="planting-hybrid"
    />
  );
}

export default PlantingHybridPanel;
